import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Button } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
export const BackButton = ({ onClick }) => {
    const { t } = useTranslation();
    return (_jsx(Button, { "data-testid": "back-to-passwordless-invalid-button", variant: "link", a11yLabel: "Back button", onClick: onClick, marginTop: 'spaceS', size: ['medium'], children: t('loginregistration.passwordless.invalidLink.backButton') }));
};
//# sourceMappingURL=BackButton.js.map